import { render } from "./PartHeader.vue?vue&type=template&id=0505de95&scoped=true"
import script from "./PartHeader.vue?vue&type=script&lang=js"
export * from "./PartHeader.vue?vue&type=script&lang=js"

import "./PartHeader.vue?vue&type=style&index=0&id=0505de95&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0505de95"]])

export default __exports__